@switch (type()) {
  @case (typer['møte']) {
    <mat-icon fontSet="ion-ios-calendar-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.oppgave) {
    <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon" [inline]="inline()"/>
  }
  @case (typer.beslutning) {
    <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon" [inline]="inline()"/>
  }
  @case (typer.dokument) {
    <mat-icon fontSet="lederplan-ikon-dokument" class="mat-icon--lederplan-ikon" [inline]="inline()"/>
  }
  @case (typer.medlem) {
    <mat-icon fontSet="ion-ios-person-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.bruker) {
    <mat-icon fontSet="ion-ios-person-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.rollePeriode) {
    <mat-icon fontSet="ion-ios-person-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer['møtedeltaker']) {
    <mat-icon fontSet="ion-ios-person-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer['protokollførtMøtedeltaker']) {
    <mat-icon fontSet="ion-ios-person-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.signatar) {
    <mat-icon fontSet="lederplan-ikon-signer" class="mat-icon--lederplan-ikon" [inline]="inline()"/>
  }
  @case (typer.medlemsRolle) {
    <mat-icon fontSet="ion-ios-people-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.gruppe) {
    <mat-icon fontSet="ion-ios-people-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.sak) {
    <mat-icon fontSet="ion-ios-paper-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.kommentar) {
    <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.svar) {
    <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.opplastetDokumentVersjon) {
    <mat-icon fontSet="lederplan-ikon-dokument" class="mat-icon--lederplan-ikon" [inline]="inline()"/>
  }
  @case (typer.arkivMappenode) {
    <mat-icon fontSet="ion-ios-folder-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  @case (typer.arkivnode) {
    <mat-icon fontSet="ion-ios-folder-outline" class="mat-icon--ionic-ikon" [inline]="inline()"/>
  }
  <!--
  finnes i ajs-versjonen src/scripts/felles/direktiver/entitetIkon.ts, men er ingen gyldig entitettype
  @case (typer.epost){
  <mat-icon fontSet="ion-ios-folder-outline" class="mat-icon&#45;&#45;ionic-ikon" [inline]="inline()"/>
  }-->
  @case (typer.avstemning) {
    <mat-icon fontSet="lederplan-ikon-avstemning" class="mat-icon--lederplan-ikon" [inline]="inline()"/>
  }
  @case (typer['spørreundersøkelse']) {
    <mat-icon [inline]="inline()">content_paste_search</mat-icon>
  }
  @default {
    <mat-icon [inline]="inline()">question_mark</mat-icon>
  }
}
